import { useLoanApplicationFormStore } from "../store/loan-application-form/hooks";

import { getCookie, setCookie, deleteCookie } from "./cookieService";

const AFFILIATE_COOKIE_NAME = "affiliate-query-params";

export function storeUtmParamsInCookie() {
  const urlParams = new URLSearchParams(window.location.search);

  // == Set data into Loan Application Form Store ==
  const appFormState = useLoanApplicationFormStore.getState();

  const {
    setOrganisation,
    setRequestedLoanAmount,
    setEmail,
    setMobilePhoneNumber,
    setConsentCheckbox,
  } = appFormState;

  const amount = parseInt(urlParams.get("amount") ?? "");
  const orgNumber = urlParams.get("orgNumber");
  const email = urlParams.get("email");
  const phone = urlParams.get("phone");
  const consent = urlParams.get("consent");

  if (amount) {
    setRequestedLoanAmount(amount);
  }

  if (orgNumber) {
    setOrganisation({ organisationNumber: orgNumber, name: orgNumber });
  }

  if (email) {
    setEmail(email);
  }

  if (phone) {
    setMobilePhoneNumber(phone);
  }

  if (consent) {
    setConsentCheckbox(consent === "true");
  }

  // == Set utm data ==

  // TODO: remove this band aid fix when updated
  //  adtraction links are deployed with them, ask marketing about this.
  if (urlParams.get("at_gd")) {
    urlParams.set("utm_source", "adtraction");
  }

  if (urlParams.get("utm_source")) {
    // iterate through all the query params and store them in a cookie
    let affiliateInfo: Record<string, string | null> = {};

    try {
      affiliateInfo = Array.from(urlParams.entries()).reduce<
        Record<string, string | null>
      >((acc, [key, value]) => {
        acc[key] = value;

        return acc;
      }, {});
    } catch (error) {
      console.error("Failed to extract affiliate info", error);
    }

    // Handle special cases (that need renaming etc..)
    if (urlParams.get("utm_source") === "addrevenue.io") {
      if (urlParams.get("channelId")) {
        affiliateInfo.addrevenueChannelId = urlParams.get("channelId");
      }

      if (urlParams.get("clickId")) {
        affiliateInfo.addrevenueClickId = urlParams.get("clickId");
      }
    }

    setCookie(AFFILIATE_COOKIE_NAME, JSON.stringify(affiliateInfo));
  }
}

export function getUtmParamsFromCookie() {
  const utmDataJSONString = getCookie(AFFILIATE_COOKIE_NAME);

  try {
    const utmDataJSON = {};
    const gaCookie = getCookie("_ga");

    if (utmDataJSONString) {
      Object.assign(utmDataJSON, JSON.parse(utmDataJSONString));
    }

    if (gaCookie) {
      Object.assign(utmDataJSON, {
        ga_client_id: `${gaCookie.split(".")[2]}.${gaCookie.split(".")[3]}`,
      });
    }

    return JSON.stringify(utmDataJSON);
  } catch (e) {
    // let's log this for now in case we need to troubleshoot later
    console.error("Failed to parse affiliate info", e);
  }

  return utmDataJSONString;
}

export function deleteUtmParamsFromCookie() {
  deleteCookie(AFFILIATE_COOKIE_NAME);
}
